<template>
  <div id="app">
    <Home />
    <Exports />
    <Brief />
    <Details />
    <Learnings />
    <Projects />
    <g-footer />
  </div>
</template>

<script>
  import Home from "./components/Home.vue";
  import Exports from "./components/Exports.vue";
  import Learnings from "./components/Learnings.vue";
  import Details from "./components/Details.vue";
  import Brief from "./components/Brief.vue";
  import Projects from "./components/Projects.vue";
  import GFooter from "./components/gFooter.vue";

  export default {
    name: "App",
    components: {
      Home,
      Exports,
      Details,
      Learnings,
      Brief,
      GFooter,
      Projects,
    },
  };
</script>

<style lang="scss">
  @import "variables";
  @import url("https://fonts.googleapis.com/css2?family=Lexend:wght@400;600&display=swap");

  #app {
    font-family: "Lexend", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f7f7f7;
  }

  .heading-0 {
    color: $white;
    font-size: 52px;
    font-weight: 600;
    letter-spacing: 0px;
    line-height: 48px;
  }

  .heading-1 {
    color: $white;
    font-size: 38px;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0px;
    line-height: 48px;
  }

  .heading-2 {
    color: $white;
    font-weight: normal;
    letter-spacing: 0px;
    font-size: 30px;
    line-height: 38px;
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) {
      line-height: 28px;
      font-size: 24px;
    }
  }

  .sub-heading {
    color: $white;
    font-weight: 600;
    letter-spacing: 0px;
    font-size: 40px;
    line-height: 42.5px;

    @media (min-width: 768px) {
      font-size: 32px;
      line-height: 34px;
    }
  }

  .title-0 {
    color: $white;
    font-size: 21px;
    font-weight: 600;
    letter-spacing: 0px;
    line-height: 30px;
  }

  .title-1 {
    color: $white;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0px;
    font-size: 23px;
    line-height: 43px;

    @media (min-width: 768px) {
      font-size: 18px;
      line-height: 26px;
    }
  }

  .body-1 {
    color: $body-1;
    font-size: 18px;
    font-weight: normal;
    letter-spacing: 0px;
    line-height: 32px;
  }

  .body-2 {
    color: $body-2;
    font-weight: normal;
    letter-spacing: 0px;
    font-size: 23px;
    line-height: 40px;

    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 28px;
    }
  }

  .body-3 {
    color: $body-3;
    font-weight: normal;
    letter-spacing: 0px;
    font-size: 18px;
    line-height: 28px;

    @media (min-width: 768px) {
      font-size: 14px;
      line-height: 22px;
    }
  }

  .action {
    border: none;
    padding: 0.5rem 1rem;
    color: $white;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0px;
    line-height: 36px;
    min-width: 9.875rem;

    &--border {
      position: relative;
      background-color: transparent;
      color: $button;
      &:hover {
        &::before {
          opacity: 0.5;
        }
      }
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        border-radius: 10px 10px 10px 0;
        padding: 4px;
        background-color: $button;
        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: source-out;
        mask-composite: subtract;

        transition: opacity 250ms ease-out;
      }
    }
    &--fill {
      border-radius: 10px 0 10px 10px;
      position: relative;
      background-color: transparent;
      z-index: 1;
      overflow: hidden;

      &:hover {
        &::before {
          opacity: 0.5;
        }
      }

      &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: $button;
        z-index: -1;

        transition: opacity 250ms ease-out;
      }
    }
  }
</style>
